import { ItListItem } from 'types/graphql'

import { VoiceTipRecorderProps } from 'src/components/widgets/VoiceTipRecorder/VoiceTipRecorder'

import { itemDescriptionMap } from './ItListItemTypes'

/**
 * List of fields tolerated in the CRUD to build our components.
 */
const ITEM_HIDDEN_FIELDS = ['type', 'itListId', 'id', '__typename']

const ITEM_DETAILS_HIDDEN_FIELDS = ['id', '__typename', 'type']

// It's important to properly build an empty item to not get
// into this scenario: https://github.com/react-hook-form/react-hook-form/issues/8998
// The choice we had was '' | undefined | null, but
// - undefined is acting the same way as not defining the property wrt the issue just mentioned
// - null cannot always be used and would require some conversion when passing the object to prisma as some db column have NOT NULL attribute
// - '' cannot always be used, it would be an invalid DateTime string representation for example
export function generateEmptyItem(item: ItListItem): ItListItem {
  const emptyItem = {
    hasVoiceTip: false,
    title: '',
    url: '',
    ...item,
  }
  if (itemDescriptionMap[item.type].hasCustomFields) {
    emptyItem[item.type] = {
      ...itemDescriptionMap[item.type].generateEmptyItemDetails(),
      ...item[item.type],
    }
  }
  return emptyItem
}

export type BuilderProps = {
  index: number
  item: ItListItem
}

export type TypeBuilderProps = Omit<BuilderProps, 'item' | 'validate'> & {
  voiceTipRecorderProps: Pick<
    VoiceTipRecorderProps,
    'id' | 'type' | 'audio' | 'finalSrc'
  >
  itemId: number
}

export const isEmpty = (item: ItListItem) => {
  const itemDetails = item[item.type] || {}
  return (
    !Object.keys(item).some(
      (key) => ![...ITEM_HIDDEN_FIELDS, item.type].includes(key) && !!item[key]
    ) &&
    !Object.keys(itemDetails).some(
      (key) => !ITEM_DETAILS_HIDDEN_FIELDS.includes(key) && !!itemDetails[key]
    )
  )
}
